module.exports = {"652925100":"新和镇","652925101":"尤鲁都斯巴格镇","652925102":"依其艾日克镇","652925103":"塔什艾日克镇","652925201":"排先拜巴扎乡","652925203":"渭干乡","652925204":"玉奇喀特乡","652925205":"塔木托格拉克乡","652925402":"央塔库都片区管委会","652925500":"新和县轻工业园区生活区","652925502":"新和县物流园区生活区","652925503":"新和县新材料园区生活区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652925.json
// module id = 3238
// module chunks = 0